import { t } from 'ember-intl';

import CustomOptions from 'umg-ember-backend/components/page-builder/options/form/section/custom-options';
import InfoBox from 'umg-ember-backend/components/ui/info-box';

<template>
  {{#if @mlp.isV2}}
    <CustomOptions
      @form={{@form}}
      @elementConfig={{@elementConfig}}
      @mlp={{@mlp}}
    />
  {{else}}
    <InfoBox @type='warning' class='u-margin-small'>
      {{t 'page_builder.options.no_settings'}}
    </InfoBox>
  {{/if}}
</template>
